/**
 * @module mapbs.components.searchtip.searchtipcontent
 */
import angular from 'angular';

import './searchtip.scss';

const moduleSearchtipcontent = angular.module('mapbsSearchtipcontentModule', []);

moduleSearchtipcontent.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/searchtip', require('./searchtip.html'));
    }
);

const searchtipcontentDirective = function () {
    return {
        restrict: 'A',
        scope: true,
        controller: 'mapbsSearchtipcontentController as searchtipcontentCtrl',
        bindToController: {
            'data': '<mapbsSearchtipcontentData',
            'gmfUser': '<mapbsSearchtipcontentGmfuser',
        },
        templateUrl: () => 'mapbs/searchtip',
    };
};

moduleSearchtipcontent.directive('mapbsSearchtipcontent', searchtipcontentDirective);

/**
 * @typedef {{
 *   'theme': string,
 *   'code': string,
 *   'example': string,
 *   'raid': number
 * }}
 */
let SearchTipItem; // eslint-disable-line no-unused-vars

class SearchtipcontentController {
    /**
   * @constructor
   * @private
   * @ngInject
   */
    constructor() {
    /**
     * @type {Array.<SearchTipItem>}
     */
        this.data;

        /**
     * @type {gmfx.User}
     */
        this.gmfUser;
    }
}

moduleSearchtipcontent.controller(
    'mapbsSearchtipcontentController',
    SearchtipcontentController
);

export default moduleSearchtipcontent;
